// extracted by mini-css-extract-plugin
module.exports = {"menu_item":"DatevListItem_menu_item__1GTUY","download_icon":"DatevListItem_download_icon__Dq6Na","my_grid":"DatevListItem_my_grid__1ps76"};